import { render, staticRenderFns } from "./SectionForm.vue?vue&type=template&id=327af35e&scoped=true"
import script from "./SectionForm.vue?vue&type=script&lang=js"
export * from "./SectionForm.vue?vue&type=script&lang=js"
import style0 from "./SectionForm.vue?vue&type=style&index=0&id=327af35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327af35e",
  null
  
)

export default component.exports